import { createSelector } from "reselect";
import getElementStatusFilter from "./get_element_status_filter";

const getDetectedClashesShown = createSelector([
  getElementStatusFilter
], (filter) => filter.detectedObstructingElementsShown);

export default getDetectedClashesShown;
